@if (isLoading) {
  <div class="col-12">
    <agmo-loading></agmo-loading>
  </div>
}

@if (!isLoading) {
  <!-- AI Chatbot Banner -->
  @if (chatbotUrl) {
    <div class="row justify-content-center mb-4">
      <div class="col-12">
        <div class="tw-rounded-lg tw-bg-[#2C2C2C] tw-p-6 tw-text-white">
          <div class="tw-flex tw-items-start tw-gap-4">
            <div class="tw-flex-shrink-0">
              <div class="tw-inline-flex tw-rounded-full tw-bg-white tw-p-3">
                <svg
                  class="tw-h-8 tw-w-8 tw-text-[#2C2C2C]"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 2C11.4 2 11 2.4 11 3V4H7C5.3 4 4 5.3 4 7V9H2V15H4V17C4 18.7 5.3 20 7 20H17C18.7 20 20 18.7 20 17V15H22V9H20V7C20 5.3 18.7 4 17 4H13V3C13 2.4 12.6 2 12 2ZM7 6H17C17.6 6 18 6.4 18 7V17C18 17.6 17.6 18 17 18H7C6.4 18 6 17.6 6 17V7C6 6.4 6.4 6 7 6ZM8.5 9C7.7 9 7 9.7 7 10.5C7 11.3 7.7 12 8.5 12C9.3 12 10 11.3 10 10.5C10 9.7 9.3 9 8.5 9ZM15.5 9C14.7 9 14 9.7 14 10.5C14 11.3 14.7 12 15.5 12C16.3 12 17 11.3 17 10.5C17 9.7 16.3 9 15.5 9ZM8 14C7.4 14 7 14.4 7 15C7 15.6 7.4 16 8 16H16C16.6 16 17 15.6 17 15C17 14.4 16.6 14 16 14H8Z"
                  />
                </svg>
              </div>
            </div>
            <div class="tw-flex-1">
              <h3 class="tw-mb-2 tw-text-xl tw-font-bold tw-text-white">
                Ask our AI about the campaign
              </h3>
              <p class="tw-mb-4 tw-text-sm tw-text-gray-300">
                Get instant answers about {{ companyName }}'s campaign details, financials, and
                more.
              </p>
              <button
                type="button"
                class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-white tw-px-6 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-[#2C2C2C] tw-transition-colors hover:tw-bg-gray-100"
                (click)="openAIChatbot()"
              >
                Ask AI Chatbot
                <svg class="tw-h-4 tw-w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="row justify-content-center mb-5">
    <div class="col-12">
      <div class="d-flex mb-4">
        <img
          class="profile-image"
          alt="pitchIN User"
          [src]="profile?.photoAttachmentUrl || defaultProfileImage"
        />
        <div class="w-100 text-right">
          <form (ngSubmit)="submitQuestion()" #form [class.show-form-error]="showFormError">
            <div class="input-field mb-3">
              @if (ckEditorLoaded) {
                <ckeditor
                  class="ck-editor"
                  [editor]="Editor"
                  [config]="ckEditorConfig"
                  (ready)="onEditorReady($event)"
                  [(ngModel)]="questionContent"
                  name="questionContent"
                  required
                ></ckeditor>
              } @else {
                <textarea
                  class="form-control"
                  rows="4"
                  [(ngModel)]="questionContent"
                  name="questionContent"
                  [placeholder]="'campaign.gotQuestionFor' | translate: { company: companyName }"
                  required
                ></textarea>
              }
            </div>
            <button type="submit" class="btn btn-primary">
              {{ 'campaign.post' | translate }}
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex mb-3">
      <div class="text-green font-weight-extrabold title mr-2">
        {{ 'campaign.q&a' | translate }}
      </div>
      <div class="light-grey font-size-larger align-self-center">({{ questionsTotal }})</div>
    </div>
    <div class="col-12">
      @for (question of questions; track question; let i = $index) {
        <div class="d-flex mb-4" [class.deleted-question]="question.isDeleted">
          <img
            class="profile-image"
            [alt]="question.creator?.fullName"
            [src]="question.creator?.photoAttachmentUrl || defaultProfileImage"
          />
          <div class="question-content">
            <div class="d-flex mb-3">
              <div class="name-panel d-flex flex-wrap">
                <div class="text-black font-weight-extrabold mr-2 mb-2">
                  {{ question.creator?.fullName }}
                </div>
                @if (question.isCreator) {
                  <div class="role">
                    {{ 'campaign.creator' | translate }}
                  </div>
                }
              </div>
              @if (!question.isDeleted) {
                <div class="date-panel text-right light-grey">
                  {{ transformDate(question.createdAt) }}
                </div>
              }
            </div>
            @if (!question.isDeleted) {
              <div class="mb-3 font-size-smaller">
                <div class="ck-content" [innerHTML]="renderQaText(question.text) | trustSrc"></div>
              </div>
            }
            @if (question.isDeleted) {
              <div class="mb-3 font-size-smaller">
                {{ 'campaign.questionDeleted' | translate }}
              </div>
            }
            @if (!question.isDeleted) {
              <div class="d-flex">
                <div class="font-weight-bold text-primary w-100">
                  <span class="cursor-pointer font-size-smaller" (click)="replyQuestion(question)">
                    {{ 'campaign.reply' | translate }}</span
                  >
                </div>
                <!-- <div class="pitchin-icon pitchin-icon-delete" *ngIf="isIssuer || question.isPostOwner"
                        (click)="deleteQuestion(question.id)"></div> -->
              </div>
            }
            @if (question.showReply) {
              <div class="d-flex my-3">
                <img
                  class="profile-image"
                  alt="pitchIN User"
                  [src]="profile?.photoAttachmentUrl || defaultProfileImage"
                />
                <div class="w-100 text-right">
                  <form
                    (ngSubmit)="submitAnswer(question)"
                    #answerForm
                    [class.show-form-error]="showAnswerFormError"
                  >
                    <div class="input-field mb-3">
                      @if (ckEditorLoaded) {
                        <ckeditor
                          class="ck-editor"
                          [editor]="Editor"
                          [config]="ckEditorConfig"
                          (ready)="onEditorReady($event)"
                          [(ngModel)]="replyContent"
                          name="replyContent"
                          required
                        ></ckeditor>
                      } @else {
                        <textarea
                          class="form-control"
                          rows="4"
                          [(ngModel)]="replyContent"
                          name="replyContent"
                          required
                        ></textarea>
                      }
                    </div>
                    <button type="submit" class="btn btn-primary">
                      {{ 'campaign.post' | translate }}
                    </button>
                  </form>
                </div>
              </div>
            }
            @for (reply of question.answers?.data; track reply; let i = $index) {
              <div class="d-flex reply-item">
                <img
                  class="profile-image"
                  [alt]="reply.creator?.fullName"
                  [src]="reply.creator?.photoAttachmentUrl || defaultProfileImage"
                />
                <div class="question-content">
                  <div class="d-flex mb-3">
                    <div class="name-panel d-flex flex-wrap">
                      <div class="text-black font-weight-extrabold mr-2 mb-2">
                        {{ reply.creator?.fullName }}
                      </div>
                      @if (reply.isCreator) {
                        <div class="role">
                          {{ 'campaign.creator' | translate }}
                        </div>
                      }
                    </div>
                    <div class="date-panel w-50 text-right light-grey">
                      {{ transformDate(reply.createdAt) }}
                    </div>
                  </div>
                  <div class="mb-3 font-size-smaller">
                    <div class="ck-content" [innerHTML]="renderQaText(reply.text) | trustSrc"></div>
                  </div>
                  @if (profile) {
                    <div class="d-flex">
                      <div class="font-weight-bold text-primary w-100">
                        <span
                          class="cursor-pointer font-size-smaller"
                          (click)="replyQuestion(reply)"
                        >
                          {{ 'campaign.reply' | translate }}</span
                        >
                      </div>
                      <!-- <div class="pitchin-icon pitchin-icon-delete" *ngIf="isIssuer || reply.isPostOwner"
                                  (click)="deleteAnswer(question, reply.id)"></div> -->
                    </div>
                  }
                  @if (reply.showReply) {
                    <div class="d-flex my-3">
                      <img
                        class="profile-image"
                        alt="pitchIN User"
                        [src]="profile?.photoAttachmentUrl || defaultProfileImage"
                      />
                      <div class="w-100 text-right">
                        <form
                          (ngSubmit)="submitAnswer(reply)"
                          #answerForm
                          [class.show-form-error]="showAnswerFormError"
                        >
                          <div class="input-field mb-3">
                            @if (ckEditorLoaded) {
                              <ckeditor
                                class="ck-editor"
                                [editor]="Editor"
                                [config]="ckEditorConfig"
                                (ready)="onEditorReady($event)"
                                [(ngModel)]="replyContent"
                                name="replyContent"
                                required
                              ></ckeditor>
                            } @else {
                              <textarea
                                class="form-control"
                                rows="4"
                                [(ngModel)]="replyContent"
                                name="replyContent"
                                required
                              ></textarea>
                            }
                          </div>
                          <button type="submit" class="btn btn-primary">
                            {{ 'campaign.post' | translate }}
                          </button>
                        </form>
                      </div>
                    </div>
                  }
                  @for (subreply of reply.answers?.data; track subreply; let i = $index) {
                    <div class="d-flex mt-4 subreply-item">
                      <img
                        class="profile-image"
                        [alt]="subreply.creator?.fullName"
                        [src]="subreply.creator?.photoAttachmentUrl || defaultProfileImage"
                      />
                      <div class="question-content">
                        <div class="d-flex mb-3">
                          <div class="name-panel d-flex flex-wrap">
                            <div class="text-black font-weight-extrabold mr-2 mb-2">
                              {{ subreply.creator?.fullName }}
                            </div>
                            @if (subreply.isCreator) {
                              <div class="role">
                                {{ 'campaign.creator' | translate }}
                              </div>
                            }
                          </div>
                          <div class="date-panel w-50 text-right light-grey">
                            {{ transformDate(subreply.createdAt) }}
                          </div>
                        </div>
                        <div class="mb-3 font-size-smaller">
                          <div
                            class="ck-content"
                            [innerHTML]="renderQaText(subreply.text) | trustSrc"
                          ></div>
                        </div>
                        <!-- <div class="d-flex justify-content-end">
                                        <div class="pitchin-icon pitchin-icon-delete" *ngIf="isIssuer || subreply.isPostOwner"
                                        (click)="deleteAnswer(reply, subreply.id)"></div>
                                      </div> -->
                      </div>
                    </div>
                  }
                  @if (
                    reply.answers &&
                    reply.answers.data &&
                    reply.answers.total - reply.answers.data.length > 0
                  ) {
                    <div class="view-more reply-view-more" (click)="getAnswerList(reply)">
                      {{
                        'campaign.viewMoreReplies'
                          | translate: { total: reply.answers.total - reply.answers.data.length }
                      }}
                    </div>
                  }
                </div>
              </div>
            }
            @if (
              question.answers &&
              question.answers.data &&
              question.answers.total - question.answers.data.length > 0
            ) {
              <div class="view-more reply-view-more" (click)="getAnswerList(question)">
                {{
                  'campaign.viewMoreReplies'
                    | translate: { total: question.answers.total - question.answers.data.length }
                }}
              </div>
            }
          </div>
        </div>
      }
    </div>
    @if (questionsTotal > questions.length) {
      <div class="col-12 d-flex mb-3">
        <div class="view-more" (click)="loadMore()">
          {{
            'campaign.viewMoreQuestions' | translate: { total: questionsTotal - questions.length }
          }}
        </div>
      </div>
    }
    @if (!questions || questions.length == 0) {
      <div class="col-12 pb-5 text-center">
        <app-empty-state></app-empty-state>
      </div>
    }
  </div>
}
